<template>
    <master-page v-if="!globalState.loading">

        <div id="main-strip" class="flex flex-col space-x-3 xl:flex-row px-4 pt-7">
            <section class="w-full xl:w-service-menu relative">                
                <ServiceMenu/>                
            </section>

            <section class="w-full xl:w-slider mt-8 xl:mt-0">
                <div class="pt-3">
                    <router-link 
                        :to="{ name: 'list', params: {slug: 'destaque'}}"
                        class="flex justify-between items-center w-full cursor-default"
                    >
                        <h1 class="text-brand font-bold text-2xl pb-4 cursor-pointer">Fique por Dentro</h1>
                        
                    </router-link> 
                                        
                    <Slider 
                        class="lg:hidden mt-1"
                        :slides="state.lastNews" 
                        :options="state.sliderOptions"
                        legendPosition="inside"
                        sliderClasses="w-full"                        
                        headingClasses="text-white"
                    />
                    
                    <Slider 
                        class="hidden lg:flex mt-1"
                        :slides="state.lastNews" 
                        :options="state.sliderOptions2"                        
                        sliderClasses="w-full overflow-y-hidden rounded-lg"
                        imageClasses="w-full rounded-lg"                                            
                        legendClasses="hover:bg-gray-200 rounded-lg"
                        headingClasses="leading-5 pr-3 text-gray-500"
                    />
                </div>
            </section>
        </div>
        
        <router-link 
            :to="{ name: 'list', params: {slug: 'destaque'}}"
            class="flex justify-end items-center cursor-default mt-3 px-10"
        >
            <span class="text-brand text-base hover:underline cursor-pointer">[Ver +]</span>
        </router-link>        

        <div id="second-strip" class="flex flex-wrap items-start justify-center p-2 pb-5">
           
            <section class="flex flex-col w-full max-w-xl xl:max-w-none md:w-1/2 xl:w-1/3 px-2 py-4">
                <Card title="Aniversariantes" class="h-72" bodyClasses="p-3 overflow-hidden">
                    <List                            
                        :items="state.birthdays"                        
                        listClasses='flex flex-col space-y-2 lg:px-1 overflow-y-auto h-full w-full'
                        listItemClasses='flex items-center hover:bg-gray-100 hover:bg-opacity-60 rounded-xl pr-3'                       
                        contentImageClasses='w-20 border border-gray-100 overflow-hidden h-auto rounded-l-xl'
                        contentTitleClasses='text-brand ml-1 font-bold text-left text-lg leading-6 w-full'
                        contentInfoClasses='text-brand ml-1 block'
                        hintProp="department"
                    />
                </Card>                    
            </section>

            <section class="flex flex-col w-full max-w-xl xl:max-w-none md:w-1/2 xl:w-1/3 px-2 py-4">
                <Card class="w-full" bodyClasses="w-full overfow-hidden">
                    <template v-slot:card-title>
                        <router-link 
                            :to="{ name: 'list', params: {slug: 'fica-a-dica'}}"
                            class="flex justify-between items-center w-full cursor-default"
                        >
                            <h1 class="text-white ml-2 mt-8 lg:mt-0 text-xl cursor-pointer">Fica a Dica</h1>
                            <span class="text-white mr-3 text-lg hover:underline cursor-pointer">[Ver +]</span>
                        </router-link>                                                   
                    </template>                        
                
                    <Slider 
                        :slides="state.tips" 
                        :options="state.sliderOptions3"
                        :legendHidden="true"
                        sliderClasses="w-full"
                        imageClasses="rounded-b-xl w-full h-auto"                             
                    />   

                </Card>
            </section>

            <section class="flex flex-col w-full max-w-xl xl:max-w-none md:w-1/2 xl:w-1/3 px-2 py-4">                    
                    
                <Card class="h-72" bodyClasses="text-brand font-bold overflow-hidden p-3">
                    <template v-slot:card-title>
                        <router-link 
                            :to="{name: 'list', params: {slug: 'diretoria-geral'}}" 
                            class="flex justify-between items-center w-full cursor-default"
                        >
                            <h1 class="text-white ml-2 mt-8 lg:mt-0 text-xl cursor-pointer">Diretoria-Geral</h1>
                            <span class="text-white mr-3 text-lg hover:underline cursor-pointer">[Ver +]</span>
                        </router-link>
                    </template>

                    <List                            
                        :items="state.generalBoard"                        
                        :noImage="true"
                        :noAbstract="true"
                        listClasses='flex-col items-center h-full overflow-y-auto divide-y divide-gray-200'
                        listItemClasses='text-justify py-2 px-2'                       
                        contentTitleClasses='text-base leading-5 pr-3'                        
                    />                    
                </Card>
                
            </section>
      
            <section class="flex flex-col w-full max-w-xl xl:max-w-none md:w-1/2 xl:w-1/3 px-2 py-4">
                <Card title="Projetos Institucionais" class="h-72" bodyClasses="p-3 overflow-hidden"> 
                    <List                            
                        :items="state.projects"                        
                        :imageOnly="true"
                        :useFallbackImage="true"                      
                        listClasses='flex flex-wrap items-center justify-center h-full overflow-y-auto'
                        listItemClasses='text-justify py-3 px-2'                       
                        contentImageClasses='w-40 border rounded'
                    />              
                </Card>                   
            </section>

            <section class="flex flex-col w-full max-w-xl xl:max-w-none md:w-1/2 xl:w-1/3 px-2 py-4">
                <Card class="h-72" bodyClasses="w-full overfow-hidden">
                    <template v-slot:card-title>                      
                        <router-link 
                            :to="{ name: 'list', params: { slug: 'expresso-mp' } }" 
                            class="flex justify-between items-center w-full cursor-default"
                        >
                            <h1 class="text-white ml-2 mt-8 lg:mt-0 text-xl cursor-pointer">Expresso MPTO</h1>
                            <span class="text-white mr-3 text-lg hover:underline cursor-pointer">[Ver +]</span>
                        </router-link>
                    </template>

                    <Slider 
                        :slides="state.express" 
                        :options="state.sliderOptions3"
                        :legendHidden="true"
                        sliderClasses="w-full"
                        imageClasses="rounded-b-xl w-full h-auto"                           
                    />                    
                </Card>
            </section>

            <section class="flex flex-col w-full max-w-xl xl:max-w-none md:w-1/2 xl:w-1/3 px-2 py-4">                    
               <Card class="h-72" bodyClasses="w-full overfow-hidden">
                    <template v-slot:card-title>                      
                        <router-link 
                            :to="{ name: 'list', params: { slug: 'videos' } }" 
                            class="flex justify-between items-center w-full cursor-default"
                        >
                            <h1 class="text-white ml-2 mt-8 lg:mt-0 text-xl cursor-pointer">Vídeos</h1>
                            <span class="text-white mr-3 text-lg hover:underline cursor-pointer">[Ver +]</span>
                        </router-link>
                    </template>

                    <Slider 
                        :slides="state.videos" 
                        :options="state.sliderOptions3"
                        :legendHidden="true"
                        sliderClasses="w-full"
                        imageClasses="rounded-b-xl w-full h-auto"                           
                    />                    
                </Card>
            </section>

        </div>
    </master-page>

    <Spinner v-else/>

</template>

<script>

import { reactive, onMounted, inject } from 'vue'

import MasterPage from '@/views/MasterPage/'
import ServiceMenu from '@/views/MasterPage/ServiceMenu'

import Card from '@/components/card'
import List from '@/components/list'
import Slider from '@/components/slider'
import Spinner from '@/components/spinner'

import api from '@/services'
import { urlFor } from '@/helpers'

export default {
    components: {
        MasterPage,
        ServiceMenu,
        Card,
        List,
        Slider,
        Spinner
    },

    setup() {
        const mkUrl = urlFor

        const routeParams = async (name, params) => {
            return {
                name,
                params
            }
        }

        const sliderOptions = {
            arrows: true,
            pagination: false,
            autoplay: true,
            rewind: true
        }

        const globalState = inject('globalState')
        
        const state = reactive({
            routeParams,
            mkUrl,
            lastNews: [],
            birthdays: [],
            projects: [],
            tips: [],
            generalBoard: [],
            express: [],
            videos: [],
            sliderOptions,
            sliderOptions2: {
                ...sliderOptions, arrows: false, width: '80%', heightRatio: 0.5625
            },
            sliderOptions3: {
                ...sliderOptions, autoplay: false
            },
            loading: globalState.loading      
        })

        globalState.loadingTasks += 7
        onMounted( async () => {            
            state.lastNews = await api.post.getLastNews()
            globalState.loadingTasks--            

            state.projects = await api.post.institutionalProjects()
            globalState.loadingTasks--            

            state.birthdays = await api.rh.todayBirthdays()
            globalState.loadingTasks--            

            state.tips = await api.post.tip()
            globalState.loadingTasks--            

            state.generalBoard = await api.post.generalBoard()
            globalState.loadingTasks--            

            state.express = await api.post.express()
            globalState.loadingTasks--            

            state.videos = await api.post.videos()
            globalState.loadingTasks--
            
            state.loading = globalState.loading
        })        

       return {
            state,
            globalState
        }
    }
}
</script>

<style lang="css">
#slider li:hover a *, .title-blue, .active-title, .text-brand
{ color: #005a86; }
</style>